import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const    GetProcedureDetailByID = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Procedure/GetDetail?` + params, null);

export const GetProcedureList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Procedure/GetList?` + params, null);

export const CreateProcedure = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Procedure/Create`, data);

export const UpdateProcedure = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Procedure/Update`, data);

export const DeleteProcedure = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Procedure/Delete`, data);